import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-portal-rt_success",
  "use": "rt-portal-rt_success-usage",
  "viewBox": "-823 -127 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"-823 -127 1024 1024\" id=\"rt-portal-rt_success\">\n<g>\n\t<path d=\"M-311,833c-246.4,0-448-201.6-448-448S-557.4-63-311-63s448,201.6,448,448S-64.6,833-311,833z M-311,11.7\n\t\tc-205.3,0-373.3,168-373.3,373.3s168,373.3,373.3,373.3S62.3,590.3,62.3,385S-105.7,11.7-311,11.7z\" />\n\t<path d=\"M-175.2,257.7l-166.9,166.9c-6.2,6.2-16.4,6.2-22.6,0l-82-82c-14-14-36.9-14-50.9,0l0,0c-14,14-14,36.9,0,50.9l118.8,118.8\n\t\tl0,0l0,0c2.6,2.6,5.6,4.8,8.7,6.4c0.5,0.3,1.1,0.5,1.6,0.8c1.1,0.5,2.2,0.9,3.3,1.3c0.6,0.2,1.1,0.4,1.7,0.5\n\t\tc1.7,0.5,3.4,0.9,5.1,1.1c1.1,0.2,2.3,0.3,3.4,0.3c2.3,0.1,4.6,0,6.9-0.3c1.1-0.2,2.3-0.4,3.4-0.7c6.2-1.5,12.1-4.7,16.9-9.5h0\n\t\tl203.6-203.6c14-14,14-36.9,0-50.9l0,0C-138.3,243.7-161.2,243.7-175.2,257.7z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/rt_success.svg
// module id = 1295
// module chunks = 116